module.exports = __webpack_public_path__ + "static/media/uta_logo.bf91d357.svg";